




































































import DocumentLink from '@/components/DocumentLink'

export default {
    name: 'Card'

    components:
        DocumentLink: DocumentLink

    data: -> fields: @defaultFields()

    computed:
        imageHeight: -> @$parent.fields.image_height
        isSmall: -> @$parent.smallCards
        textAlign: ->
            'center': @fields.text_align is 'zentriert'
            'left': @fields.text_align is 'links'
            'right': @fields.text_align is 'rechts'

    methods:
        defaultFields: ->
            image: []
            title: [],
            text: [],
            subtitle: [],
            button_title: [],
            button_link: [],
            text_align: 'zentriert'

        setContent: (document) ->
            fields =
                image: document.image
                title: document.title
                text: document.text
                subtitle: document.subtitle
                button_title: document.button_title
                button_link: document.button_link
            $.extend @fields, fields

    created: ->
        @setContent @$attrs.document
}
